module.exports = __webpack_public_path__ + "static/img/industries11.68b541a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industries11.png
// module id = uFS6
// module chunks = 1